import { Component, Input } from '@angular/core';
import { FuncService } from '../../../common/services/func.service';

@Component({
  selector: 'number-cell',
  template: `    
    <p class="fz-14 c-999999 ta-l"
       data-toggle="tooltip"
       tooltip="{{ customNumFormat(numberValue).original }}"
       placement="right">{{ customNumFormat(numberValue).short }}</p>
  `,
  styles: [
    `
    :host-context(.header-values-white) /deep/ p{
      color: white;
    }
    `
  ]
})
export class NumberCellComponent {
  constructor(private fs: FuncService) {}
  @Input() numberValue;

  customNumFormat(number) {
    return this.fs.customNumFormat(number);
  }
}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/components-utl-per-fin/number-cell/number-cell.component.ts